/**
 * Audio upload size limit (CHAT-27).
 *
 * The server is the source of truth: `GET /api/transcriptions/formats` returns
 * `max_size_mb` from `settings.AUDIO_MAX_SIZE_MB`
 * (backend/app/core/config.py, default 100). DEFAULT_AUDIO_MAX_MB is only the
 * fallback used until that response arrives (or if it fails); keep it equal
 * to the backend default.
 */
import type { TranscriptionFormatsResponse } from '../types/transcription';

export const DEFAULT_AUDIO_MAX_MB = 100;

export function resolveAudioMaxMb(
  limits: Pick<TranscriptionFormatsResponse, 'max_size_mb'> | null | undefined,
): number {
  const fromServer = limits?.max_size_mb;
  return typeof fromServer === 'number' && fromServer > 0 ? fromServer : DEFAULT_AUDIO_MAX_MB;
}

export function audioMaxBytes(maxMb: number): number {
  return maxMb * 1024 * 1024;
}

/**
 * Params for `transcription.errors.fileTooLarge`, whose template needs both
 * `{{size}}` (the picked file, MB) and `{{max}}` (the limit, MB).
 */
export function audioFileTooLargeParams(fileBytes: number, maxMb: number): { size: string; max: number } {
  return { size: (fileBytes / (1024 * 1024)).toFixed(1), max: maxMb };
}
